// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"A0-z","displaySixCardTiles":"B0-z"};